import { render, staticRenderFns } from "./discountAliasEdit.vue?vue&type=template&id=73c0e397&scoped=true&lang=html&"
import script from "./discountAliasEdit.vue?vue&type=script&lang=js&"
export * from "./discountAliasEdit.vue?vue&type=script&lang=js&"
import style0 from "./discountAliasEdit.vue?vue&type=style&index=0&id=73c0e397&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c0e397",
  null
  
)

export default component.exports